export default {
  index: {
    // 页面标题
    title: 'Setting',
  },
};
